"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TheHarvestGallery() {
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_harvest_basket.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_harvest_basket.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_harvest_basket.webp-wvc-sizes",
    alt: "Woven basket overflowing with seasonal heirloom vegetables",
    caption: "§ HARVEST",
    coords: "42.3601° N",
    span: "md:col-span-7 md:row-span-2",
    aspect: "aspect-[4/5] md:aspect-auto md:h-full"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_seedlings_tray.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_seedlings_tray.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_seedlings_tray.png-wvc-sizes",
    alt: "Young organic seedlings thriving in a sunlit greenhouse",
    caption: "§ GREENHOUSE",
    coords: "71.0589° W",
    span: "md:col-span-5 md:row-span-1",
    aspect: "aspect-[16/9]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/compost_turning_tools.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/compost_turning_tools.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/compost_turning_tools.png-wvc-sizes",
    alt: "Hand tools resting on rich, dark organic compost",
    caption: "§ COMPOST",
    coords: "42.3611° N",
    span: "md:col-span-3 md:row-span-1",
    aspect: "aspect-[4/5]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_garden_plot.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_garden_plot.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_garden_plot.png-wvc-sizes",
    alt: "Lush community garden plot with raised wooden beds",
    caption: "§ PLOTS",
    coords: "71.0612° W",
    span: "md:col-span-5 md:row-span-1",
    aspect: "aspect-[16/9]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/workshop_gardening_tools.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/workshop_gardening_tools.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/workshop_gardening_tools.png-wvc-sizes",
    alt: "Organized gardening tools laid out for a workshop",
    caption: "§ WORKSHOP",
    coords: "42.3622° N",
    span: "md:col-span-4 md:row-span-1",
    aspect: "aspect-[4/5] md:aspect-[5/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_gathering_space.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_gathering_space.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_gathering_space.png-wvc-sizes",
    alt: "Community members gathering in the garden at sunset",
    caption: "§ GATHERING",
    coords: "71.0594° W",
    span: "md:col-span-8 md:row-span-1",
    aspect: "aspect-[16/9]"
  }];
  const tickerItems = ["HEIRLOOM TOMATOES", "ORGANIC COMPOST", "SEED SWAPPING", "SEASONAL HARVEST", "COMMUNITY PLOTS"];
  return <section data-section-id="1695" id="the-harvest-gallery" className="dark bg-background text-foreground relative overflow-hidden py-28 md:py-40">
      <div className="mx-auto w-full max-w-[1320px] px-5 sm:px-8 md:px-14">
        {}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
          {}
          <div className="md:col-span-8">
            {}
            <div className="flex items-center gap-4">
              <span className="font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--chart-1)"
            }}>The Harvest Gallery</span>
            </div>
            <div className="mt-3 flex items-center gap-2">
              <span className="inline-block h-1 w-1 rounded-md" style={{
              backgroundColor: "var(--chart-1)"
            }} aria-hidden="true" />
              <span className="block h-px w-14" style={{
              backgroundColor: "var(--chart-1)"
            }} aria-hidden="true" />
            </div>

            {}
            <h2 className="mt-8 font-serif text-[clamp(2.25rem,4.6vw,4.25rem)] font-normal leading-[0.98] tracking-[-0.02em] text-foreground">
              A garden grown like a{" "}
              <em className="font-serif italic" style={{
              color: "var(--chart-1)"
            }}>
                community
              </em>
              , not a crop.
            </h2>
          </div>

          {}
          <div className="md:col-span-4 md:pt-4">
            <p className="text-[clamp(1rem,1.05vw,1.0625rem)] leading-[1.62] font-default" style={{
            color: "var(--muted-foreground)"
          }}>
              Heirloom seeds, nutrient-rich organic compost, and shared knowledge
              cultivated together. Every plot is a space for growth — so your
              neighborhood thrives as much as the harvest.
            </p>
            <div className="mt-8">
              <Link to="/JoinUsPage" className="group inline-flex items-center gap-3 font-default text-sm font-medium text-foreground">
                <span className="relative pb-1.5">
                  Download Planting Guide
                  <span className="absolute bottom-0 left-0 h-px w-full origin-left scale-x-0 transition-transform duration-[280ms] ease-out group-hover:scale-x-100" style={{
                  backgroundColor: "var(--chart-1)"
                }} />
                </span>
                <ArrowRight className="size-4 transition-transform duration-[240ms] ease-out group-hover:translate-x-1" style={{
                color: "var(--chart-1)"
              }} />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:auto-rows-[minmax(220px,1fr)] md:gap-5">
            {images.map((image, i) => <figure key={i} data-index={i} className={`group relative overflow-hidden ${image.span} ${image.aspect}`} style={{
            backgroundColor: "var(--card)"
          }}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[500ms] ease-out group-hover:scale-[1.04]" />

                {}
                <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-[300ms] ease-out group-hover:opacity-100" style={{
              boxShadow: "inset 0 0 0 1px var(--chart-1)"
            }} aria-hidden="true" />

                {}
                <span className="pointer-events-none absolute inset-x-0 bottom-0 h-24 opacity-0 transition-opacity duration-[320ms] ease-out group-hover:opacity-100" style={{
              background: "linear-gradient(to top, hsla(180, 12%, 6%, 0.85), hsla(180, 12%, 6%, 0))"
            }} aria-hidden="true" />

                {}
                <figcaption className="pointer-events-none absolute bottom-4 left-4 translate-y-3 opacity-0 transition-all duration-[320ms] ease-out group-hover:translate-y-0 group-hover:opacity-100 font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--chart-1)"
            }}>
                  {image.caption}
                </figcaption>

                {}
                <span className="pointer-events-none absolute bottom-3 right-3 font-mono text-[10px] tracking-[0.08em]" style={{
              color: "hsla(42, 58%, 58%, 0.5)"
            }}>
                  {image.coords}
                </span>
              </figure>)}
          </div>
        </div>
      </div>

      {}
      <div className="mt-20 overflow-hidden border-t border-b py-3" style={{
      borderColor: "hsla(42, 58%, 58%, 0.18)"
    }}>
        <div className="flex w-max animate-[ticker_38s_linear_infinite] items-center gap-10 whitespace-nowrap">
          {[...Array(4)].map((_, repeatIdx) => <div key={repeatIdx} data-index={repeatIdx} className="flex items-center gap-10">
              {tickerItems.map((item, j) => <div key={`${repeatIdx}-${j}`} data-index={j} className="flex items-center gap-10">
                  <span className="font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--muted-foreground)"
            }}>
                    {item}
                  </span>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                    <path d="M5 0L6 4L10 5L6 6L5 10L4 6L0 5L4 4L5 0Z" fill="var(--chart-1)" />
                  </svg>
                </div>)}
            </div>)}
        </div>
      </div>

      {}
      <div className="mx-auto w-full max-w-[1320px] px-5 sm:px-8 md:px-14">
        <span className="mt-10 inline-block font-mono text-[11px] tracking-[0.08em]" style={{
        color: "hsla(42, 58%, 58%, 0.5)"
      }}>
          42.3601° N / 71.0589° W
        </span>
      </div>

      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}